<template>
  <UPage class="bg-workbook-white">
    <UPageBody>
      <UContainer>
        <ContentRenderer v-if="page" :value="page" />
      </UContainer>
    </UPageBody>
  </UPage>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'

const route = useRoute()

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('pages').path(route.path).first()
})

const { width } = useWindowSize()

const isMobile = computed(() => width.value < 767)

useContentSeo(page)
</script>
